// extracted by mini-css-extract-plugin
module.exports = {"root":"Qualiphy_root__1aYq7","boxTitle":"Qualiphy_boxTitle__1J4g0","box":"Qualiphy_box__2PNEX","toggleWrap":"Qualiphy_toggleWrap__1chfv"};